<template>
	<div class="custom-icon" v-bind:style="{ paddingRight: paddingRight ? paddingRight : '0' }">
		<IconSvgBank :color="color" :size="size" v-if="toLowerCaseType === 'bank'" />
		<IconSvgBook :color="color" :size="size" v-else-if="toLowerCaseType === 'book'" />
		<IconSvgBookClosed
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'book_closed'"
		/>
		<IconSvgBulb :color="color" :size="size" v-else-if="toLowerCaseType === 'bulb'" />
		<IconSvgCalculator
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'calculator'"
		/>
		<IconSvgCategories
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'categories'"
		/>
		<IconSvgBuy :color="color" :size="size" v-else-if="toLowerCaseType === 'buy'" />
		<IconSvgPin
			:color="color"
			:size="size"
			:strokeColor="strokeColor"
			v-else-if="toLowerCaseType === 'pin'"
		/>
		<IconSvgCertificat
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'certificat'"
		/>
		<IconSvgChair :color="color" :size="size" v-else-if="toLowerCaseType === 'chair'" />
		<IconSvgClock :color="color" :size="size" v-else-if="toLowerCaseType === 'clock'" />
		<IconSvgCommunity :color="color" :size="size" v-else-if="toLowerCaseType === 'community'" />
		<IconSvgCompanyDirectory
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'company_directory'"
		/>
		<IconSvgGift :color="color" :size="size" v-else-if="toLowerCaseType === 'gift'" />
		<IconSvgGlobe :color="color" :size="size" v-else-if="toLowerCaseType === 'globe'" />
		<IconSvgGraduate :color="color" :size="size" v-else-if="toLowerCaseType === 'graduate'" />
		<IconSvgGraph :color="color" :size="size" v-else-if="toLowerCaseType === 'graph'" />
		<IconSvgHeadSet :color="color" :size="size" v-else-if="toLowerCaseType === 'headset'" />
		<IconSvgJobs :color="color" :size="size" v-else-if="toLowerCaseType === 'jobs'" />
		<IconSvgMegaphone :color="color" :size="size" v-else-if="toLowerCaseType === 'megaphone'" />
		<IconSvgMemberDirectory
			:isActive="isActive"
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'member_directory'"
		/>
		<IconSvgNotifications
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'notifications'"
		/>
		<IconSvgPartners :color="color" :size="size" v-else-if="toLowerCaseType === 'partners'" />
		<IconSvgScale :color="color" :size="size" v-else-if="toLowerCaseType === 'scale'" />
		<IconSvgSchool :color="color" :size="size" v-else-if="toLowerCaseType === 'school'" />
		<IconSvgArrowUp :color="color" :size="size" v-else-if="toLowerCaseType === 'arrow_up'" />
		<IconSvgBubble :color="color" :size="size" v-else-if="toLowerCaseType === 'bubble'" />
		<IconSvgCalendarCheck
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'calendar_check'"
		/>
		<IconSvgCalendarStar
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'calendar_star'"
		/>
		<IconSvgCart :color="color" :size="size" v-else-if="toLowerCaseType === 'cart'" />
		<IconSvgCheck :color="color" :size="size" v-else-if="toLowerCaseType === 'check'" />
		<IconSvgClip :color="color" :size="size" v-else-if="toLowerCaseType === 'clip'" />
		<IconSvgCloseFill
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'close_fill'"
		/>
		<IconSvgCode :color="color" :size="size" v-else-if="toLowerCaseType === 'code'" />
		<IconSvgCompass :color="color" :size="size" v-else-if="toLowerCaseType === 'compass'" />
		<IconSvgConnection
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'connection'"
		/>
		<IconSvgConvention
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'convention'"
		/>
		<IconSvgCovid :color="color" :size="size" v-else-if="toLowerCaseType === 'covid'" />
		<IconSvgDisplay :color="color" :size="size" v-else-if="toLowerCaseType === 'display'" />
		<IconSvgDollar :color="color" :size="size" v-else-if="toLowerCaseType === 'dollar'" />
		<IconSvgDownloads :color="color" :size="size" v-else-if="toLowerCaseType === 'downloads'" />
		<IconSvgEmail
			:strokeColor="strokeColor"
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'email'"
		/>
		<IconSvgEvents
			:isActive="isActive"
			:color="color"
			:size="size"
			v-else-if="toLowerCaseType === 'events'"
		/>
		<IconSvgFacebook :color="color" :size="size" v-else-if="toLowerCaseType === 'facebook'" />
		<IconSvgFlash :color="color" :size="size" v-else-if="toLowerCaseType === 'flash'" />
		<IconSvgFolder
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'folder'"
		/>
		<IconSvgForums
			:isActive="isActive"
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'forums'"
		/>
		<IconSvgGlobeCircle
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'globe_circle'"
		/>
		<IconSvgGroup
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'group'"
		/>
		<IconSvgHeadphones
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'headphones'"
		/>
		<IconSvgHigherLogic
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'higher_logic'"
		/>
		<IconSvgHome
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'home'"
		/>
		<IconSvgInfinity
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'infinity'"
		/>
		<IconSvgInfo
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'info'"
		/>
		<IconSvgInstagram
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'instagram'"
		/>
		<IconSvgLegislative
			:isActive="isActive"
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'legislative'"
		/>
		<IconSvgLink
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'link'"
		/>
		<IconSvgLinkedin
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'linkedin'"
		/>
		<IconSvgList
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'list'"
		/>
		<IconSvgLookupPeople
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'lookup_people'"
		/>
		<IconSvgMembershipCard
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'membership_card'"
		/>
		<IconSvgMessages
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'messages'"
		/>
		<IconSvgMore
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'more'"
		/>
		<IconSvgNewspaper
			:isActive="isActive"
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'newspaper'"
		/>
		<IconSvgPass
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'pass'"
		/>
		<IconSvgPause
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'pause'"
		/>
		<IconSvgPlay
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'play'"
		/>
		<IconSvgPlayCircle
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'play_circle'"
		/>
		<IconSvgPlusFill
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'plus_fill'"
		/>
		<IconSvgProfile
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'profile'"
		/>
		<IconSvgQr
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'qr'"
		/>
		<IconSvgQuestion
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'question'"
		/>
		<IconSvgRefresh
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'refresh'"
		/>
		<IconSvgResources
			:isActive="isActive"
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'resources'"
		/>
		<IconSvgSearch
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'search'"
		/>
		<IconSvgSettings
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'settings'"
		/>
		<IconSvgSort
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'sort'"
		/>
		<IconSvgStar
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'star'"
		/>
		<IconSvgStarEmpty
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'star_empty'"
		/>
		<IconSvgTarget
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'target'"
		/>
		<IconSvgTeacher
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'teacher'"
		/>
		<IconSvgTwitter
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'twitter'"
		/>
		<IconSvgUsa
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'usa'"
		/>
		<IconSvgUsers
			:isActive="isActive"
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'users'"
		/>
		<IconSvgWallet
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'wallet'"
		/>
		<IconSvgWrench
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'wrench'"
		/>
		<IconSvgACPAMyprofile
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'acpa_myprofile'"
		/>
		<IconSvgACPANewsFeed
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'acpa_newsfeed'"
		/>
		<IconSvgACTFLCentral
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'actfl_central'"
		/>
		<IconSvgAGDSubmitCEOnline
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'agd_submit_ce_online'"
		/>
		<IconSvgAMSNHome
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'amsn_home'"
		/>
		<IconSvgADAPhysicianPortal
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'ada_physician_portal'"
		/>
		<IconSvgAPAUpdates
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'apa_updates'"
		/>
		<IconSvgAPSNNews
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'apsn_news'"
		/>
		<IconSvgASTSFoundation
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'asts_foundation'"
		/>
		<IconSvgClowderLogo
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'clowder-logo'"
		/>
		<IconSvgCMAACCMDirectory
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'cmaa_ccm_directory'"
		/>
		<IconSvgCompTIAAppUsers
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'comptia_app_users'"
		/>
		<IconSvgCRNDailySupplement
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'crn_daily_supplement'"
		/>
		<IconSvgDSEALegislativeAction
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'dsea_legislative_action'"
		/>
		<IconSvgHRLFABoardOfDirectors
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'hrlfa_board_of_directors'"
		/>
		<IconSvgILMANewsFeed
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'ilma_news_feed'"
		/>
		<IconSvgMEMAHome
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'mema_home'"
		/>
		<IconSvgMEMAAHome
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'memaa_home'"
		/>
		<IconSvgMEMAHHome
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'memah_home'"
		/>
		<IconSvgMEMAMHome
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'memam_home'"
		/>
		<IconSvgMEMAOHome
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'memao_home'"
		/>
		<IconSvgMPANewsFeed
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'mpa_news_feed'"
		/>
		<IconSvgNCIAConnect
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'ncia_connect'"
		/>
		<IconSvgNPMAMyNPMA
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'npma_mynpma'"
		/>
		<IconSvgNYSSCPAChapters
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nysscpa_chapters'"
		/>
		<IconSvgNYSSCPAExchange
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nysscpa_exchange'"
		/>
		<IconSvgNYSSCPAMentormatch
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nysscpa_mentormatch'"
		/>
		<IconSvgNYSSCPAStatewideCommittees
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nysscpa_statewide_committees'"
		/>
		<IconSvgQAScholarship
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'qa_scholarship'"
		/>
		<IconSvgSCRLAServSafe
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'scrla_servsafe'"
		/>
		<IconSvgSDBPNewsFeed
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'sdbp_news_feed'"
		/>
		<IconSvgSHMemorial
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'sh_memorial'"
		/>
		<IconSvgTHYROIDNewsFeed
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'thyroid_news_feed'"
		/>
		<IconSvgZONTAMyZonta
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'zonta_myzonta'"
		/>
		<IconSvgGBANewsFeed
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'gba_news_feed'"
		/>
		<IconSvgNFOPActiveFit
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nfop_active&fit'"
		/>
		<IconSvgSNMMIConnect
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'snmmi_connect'"
		/>
		<IconSvgASCRSEyeWorld
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'ascrs_eyeworld'"
		/>
		<IconSvgPROLEGISMyProlegis
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'prolegis_myprolegis'"
		/>
		<IconSvgPROLEGISBriefings
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'prolegis_briefings'"
		/>
		<IconSvgDCAT
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'dcat'"
		/>
		<IconSvgNextGen
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nextgen'"
		/>
		<IconSvgNextGen2
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nextgen2'"
		/>
		<IconSvgNYSSCPA
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'nysscpa'"
		/>
		<IconSvgAsae
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'asae'"
		/>
		<IconSvgNews
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'news'"
		/>
		<IconSvgBinoculars
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'binoculars'"
		/>
		<IconSvgForYou
			:isActive="isActive"
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'for-you'"
		/>
		<IconSvgKey
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'key'"
		/>
		<IconSvgIdea
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'idea'"
		/>
		<IconSvgIcons8Support
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'icons8-support'"
		/>
		<IconSvgDocument
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'document'"
		/>
		<IconSvgMusic
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'music'"
		/>
		<IconSvgACPWebview
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'acp_webview'"
		/>
		<IconSvgAFPMSummit2023
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'afpm_summit_2023'"
		/>
		<IconSvgAFPM1
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'afpm1'"
		/>
		<IconSvgAFPM2
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'afpm2'"
		/>
		<IconSvgAISESIcon
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'aises_icon'"
		/>
		<IconSvgIconBee
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'icon_bee'"
		/>
		<IconSvgAFPMLiveEvent
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'afpm_live_event'"
		/>
		<IconSvgPencil
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'pencil'"
		/>
		<IconSvgPencil2
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'pencil2'"
		/>
		<IconSvgLike
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'like'"
		/>
		<IconSvgEye
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'eye'"
		/>
		<IconSvgBookmark
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'bookmark'"
		/>
		<IconSvgBookmarkEmpty
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'bookmark_empty'"
		/>
		<IconSvgPauseCircle
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'pause_circle'"
		/>
		<IconSvgFolder2
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'open_folder'"
		/>
		<IconSvgComment
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'comment'"
		/>
		<IconSvgPhone
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'phone'"
		/>
		<IconSvgPhoneEmpty
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'phone_empty'"
		/>
		<IconSvgGrid
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'grid'"
		/>
		<IconSvgGrid2
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'grid2'"
		/>
		<IconSvgChevronRight
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'chevron_right'"
		/>
		<IconSvgChevronLeft
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'chevron_left'"
		/>
		<IconSvgPlayerBack
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'player-back'"
		/>
		<IconSvgPlayerForward
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'player-forward'"
		/>
		<IconSvgVolumeDown
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'volume-down'"
		/>
		<IconSvgVolumeUp
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'volume-up'"
		/>
		<IconSvgTraForkKnifeDrk
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'fork_knife_drk'"
		/>
		<IconSvgAttachment
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'agc_braindate'"
		/>
		<IconSvgBothMessage
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'messages-both'"
		/>
		<IconSvgHearth
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'hearth'"
		/>
		<IconSvgShare
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'share'"
		/>
		<IconSvgDelete
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'delete'"
		/>
		<IconSvgVector
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'vector'"
		/>
		<IconSvgForward
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'forward'"
		/>
		<IconSvgHashTag
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'hashtag'"
		/>
		<IconSvgVideoLink
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'videolink'"
		/>
		<IconSvgClose
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'close'"
		/>
		<IconSvgUp
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'up'"
		/>
		<IconSvgNote
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'note'"
		/>
		<IconSvgEllipsis
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'ellipsis'"
		/>
		<IconSvgPinned
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'pinned'"
		/>
		<IconSvgClowderTitleLogo
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'clowder_title_logo'"
		/>
		<IconSvgUnion
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'union'"
		/>
		<IconSvgLogout
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'logout'"
		/>
		<IconSvgAddSchedule
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'add_schedule'"
		/>
		<IconSvgPlus
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'plus'"
		/>
		<IconSvgRemoveSchedule
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'remove_schedule'"
		/>
		<IconSvgChart
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'chart'"
		/>
		<IconSvgWrench2
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'wrench2'"
		/>
		<IconSvgLibrary
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'library'"
		/>
		<IconSvgBriefCase
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'briefcase'"
		/>
		<IconSvgMonitor
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'monitor'"
		/>
		<IconSvgPresentation
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'presentation'"
		/>
		<IconSvgCross
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'cross'"
		/>
		<IconSvgClipboardList
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'task-list'"
		/>
		<IconSvgLocation
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'location'"
		/>
		<IconSvgApple
			:size="size"
			:color="color || styles.navigation_bar_tint"
			v-else-if="toLowerCaseType === 'apple'"
		/>
    <IconSvgSnmmi
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi'"
    />
    <IconSvgSnmmiDirectory
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi_directory'"
    />
    <IconSvgSnnmiClinicalPractice
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snnmi_clinical_practice'"
    />
    <IconSvgSnmmiNuclearMedicineJournals
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi_nuclear_medicine_journals'"
    />
    <IconSvgSnmmiPodcast
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi_podcast'"
    />
    <IconSvgSnmmiFollowUs
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi_follow_us'"
    />
    <IconSvgSnmmiSettings
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi_settings'"
    />
    <IconSvgSnmmiNotifications
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi_notifications'"
    />
    <IconSvgSnmmiMessages
        :size="size"
        :color="color || styles.navigation_bar_tint"
        v-else-if="toLowerCaseType === 'snmmi_messages'"
    />
		<IconSvgFolder :size="size" :color="color || styles.navigation_bar_tint" v-else />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

import IconSvgBank from '@/components/Resource/Icons/IconSvgBank.vue'
import IconSvgBook from '@/components/Resource/Icons/IconSvgBook.vue'
import IconSvgBookClosed from '@/components/Resource/Icons/IconSvgBookClosed.vue'
import IconSvgBulb from '@/components/Resource/Icons/IconSvgBulb.vue'
import IconSvgCalculator from '@/components/Resource/Icons/IconSvgCalculator.vue'
import IconSvgCategories from '@/components/Resource/Icons/IconSvgCategories.vue'
import IconSvgBuy from '@/components/Resource/Icons/IconSvgBuy.vue'
import IconSvgPin from '@/components/Resource/Icons/IconSvgPin.vue'
import IconSvgCertificat from '@/components/Resource/Icons/IconSvgCertificat.vue'
import IconSvgChair from '@/components/Resource/Icons/IconSvgChair.vue'
import IconSvgClock from '@/components/Resource/Icons/IconSvgClock.vue'
import IconSvgCommunity from '@/components/Resource/Icons/IconSvgCommunity.vue'
import IconSvgCompanyDirectory from '@/components/Resource/Icons/IconSvgCompanyDirectory.vue'
import IconSvgFolder from '@/components/Resource/Icons/IconSvgFolder.vue'
import IconSvgGift from '@/components/Resource/Icons/IconSvgGift.vue'
import IconSvgGlobe from '@/components/Resource/Icons/IconSvgGlobe.vue'
import IconSvgGraduate from '@/components/Resource/Icons/IconSvgGraduate.vue'
import IconSvgGraph from '@/components/Resource/Icons/IconSvgGraph.vue'
import IconSvgHeadSet from '@/components/Resource/Icons/IconSvgHeadSet.vue'
import IconSvgJobs from '@/components/Resource/Icons/IconSvgJobs.vue'
import IconSvgMegaphone from '@/components/Resource/Icons/IconSvgMegaphone.vue'
import IconSvgMemberDirectory from '@/components/Resource/Icons/IconSvgMemberDirectory.vue'
import IconSvgNotifications from '@/components/Resource/Icons/IconSvgNotifications.vue'
import IconSvgPartners from '@/components/Resource/Icons/IconSvgPartners.vue'
import IconSvgScale from '@/components/Resource/Icons/IconSvgScale.vue'
import IconSvgSchool from '@/components/Resource/Icons/IconSvgSchool.vue'
import IconSvgArrowUp from '@/components/Resource/Icons/IconSvgArrowUp.vue'
import IconSvgBubble from '@/components/Resource/Icons/IconSvgBubble.vue'
import IconSvgCalendarCheck from '@/components/Resource/Icons/IconSvgCalendarCheck.vue'
import IconSvgCalendarStar from '@/components/Resource/Icons/IconSvgCalendarStar.vue'
import IconSvgCart from '@/components/Resource/Icons/IconSvgCart.vue'
import IconSvgCheck from '@/components/Resource/Icons/IconSvgCheck.vue'
import IconSvgClip from '@/components/Resource/Icons/IconSvgClip.vue'
import IconSvgCloseFill from '@/components/Resource/Icons/IconSvgCloseFill.vue'
import IconSvgCode from '@/components/Resource/Icons/IconSvgCode.vue'
import IconSvgCompass from '@/components/Resource/Icons/IconSvgCompass.vue'
import IconSvgConnection from '@/components/Resource/Icons/IconSvgConnection.vue'
import IconSvgConvention from '@/components/Resource/Icons/IconSvgConvention.vue'
import IconSvgCovid from '@/components/Resource/Icons/IconSvgCovid.vue'
import IconSvgDisplay from '@/components/Resource/Icons/IconSvgDisplay.vue'
import IconSvgDollar from '@/components/Resource/Icons/IconSvgDollar.vue'
import IconSvgDownloads from '@/components/Resource/Icons/IconSvgDownloads.vue'
import IconSvgEmail from '@/components/Resource/Icons/IconSvgEmail.vue'
import IconSvgEvents from '@/components/Resource/Icons/IconSvgEvents.vue'
import IconSvgFacebook from '@/components/Resource/Icons/IconSvgFacebook.vue'
import IconSvgFlash from '@/components/Resource/Icons/IconSvgFlash.vue'
import IconSvgForums from '@/components/Resource/Icons/IconSvgForums.vue'
import IconSvgGlobeCircle from '@/components/Resource/Icons/IconSvgGlobeCircle.vue'
import IconSvgGroup from '@/components/Resource/Icons/IconSvgGroup.vue'
import IconSvgHeadphones from '@/components/Resource/Icons/IconSvgHeadphones.vue'
import IconSvgHigherLogic from '@/components/Resource/Icons/IconSvgHigherLogic.vue'
import IconSvgHome from '@/components/Resource/Icons/IconSvgHome.vue'
import IconSvgInfinity from '@/components/Resource/Icons/IconSvgInfinity.vue'
import IconSvgInfo from '@/components/Resource/Icons/IconSvgInfo.vue'
import IconSvgInstagram from '@/components/Resource/Icons/IconSvgInstagram.vue'
import IconSvgLegislative from '@/components/Resource/Icons/IconSvgLegislative.vue'
import IconSvgLink from '@/components/Resource/Icons/IconSvgLink.vue'
import IconSvgLinkedin from '@/components/Resource/Icons/IconSvgLinkedin.vue'
import IconSvgList from '@/components/Resource/Icons/IconSvgList.vue'
import IconSvgLookupPeople from '@/components/Resource/Icons/IconSvgLookupPeople.vue'
import IconSvgMembershipCard from '@/components/Resource/Icons/IconSvgMembershipCard.vue'
import IconSvgMessages from '@/components/Resource/Icons/IconSvgMessages.vue'
import IconSvgMore from '@/components/Resource/Icons/IconSvgMore.vue'
import IconSvgNewspaper from '@/components/Resource/Icons/IconSvgNewspaper.vue'
import IconSvgPass from '@/components/Resource/Icons/IconSvgPass.vue'
import IconSvgPause from '@/components/Resource/Icons/IconSvgPause.vue'
import IconSvgPlay from '@/components/Resource/Icons/IconSvgPlay.vue'
import IconSvgPlayCircle from '@/components/Resource/Icons/IconSvgPlayCircle.vue'
import IconSvgPlusFill from '@/components/Resource/Icons/IconSvgPlusFill.vue'
import IconSvgProfile from '@/components/Resource/Icons/IconSvgProfile.vue'
import IconSvgQr from '@/components/Resource/Icons/IconSvgQr.vue'
import IconSvgQuestion from '@/components/Resource/Icons/IconSvgQuestion.vue'
import IconSvgRefresh from '@/components/Resource/Icons/IconSvgRefresh.vue'
import IconSvgResources from '@/components/Resource/Icons/IconSvgResources.vue'
import IconSvgSearch from '@/components/Resource/Icons/IconSvgSearch.vue'
import IconSvgSettings from '@/components/Resource/Icons/IconSvgSettings.vue'
import IconSvgSort from '@/components/Resource/Icons/IconSvgSort.vue'
import IconSvgStar from '@/components/Resource/Icons/IconSvgStar.vue'
import IconSvgStarEmpty from '@/components/Resource/Icons/IconSvgStarEmpty.vue'
import IconSvgTarget from '@/components/Resource/Icons/IconSvgTarget.vue'
import IconSvgTeacher from '@/components/Resource/Icons/IconSvgTeacher.vue'
import IconSvgTwitter from '@/components/Resource/Icons/IconSvgTwitter.vue'
import IconSvgUsa from '@/components/Resource/Icons/IconSvgUsa.vue'
import IconSvgUsers from '@/components/Resource/Icons/IconSvgUsers.vue'
import IconSvgWallet from '@/components/Resource/Icons/IconSvgWallet.vue'
import IconSvgWrench from '@/components/Resource/Icons/IconSvgWrench.vue'
import IconSvgACPAMyprofile from '@/components/Resource/Icons/IconSvgACPAMyprofile.vue'
import IconSvgACPANewsFeed from '@/components/Resource/Icons/IconSvgACPANewsFeed.vue'
import IconSvgACTFLCentral from '@/components/Resource/Icons/IconSvgACTFLCentral.vue'
import IconSvgAGDSubmitCEOnline from '@/components/Resource/Icons/IconSvgAGDSubmitCEOnline.vue'
import IconSvgAMSNHome from '@/components/Resource/Icons/IconSvgAMSNHome.vue'
import IconSvgADAPhysicianPortal from '@/components/Resource/Icons/IconSvgADAPhysicianPortal.vue'
import IconSvgAPAUpdates from '@/components/Resource/Icons/IconSvgAPAUpdates.vue'
import IconSvgAPSNNews from '@/components/Resource/Icons/IconSvgAPSNNews.vue'
import IconSvgASTSFoundation from '@/components/Resource/Icons/IconSvgASTSFoundation.vue'
import IconSvgClowderLogo from '@/components/Resource/Icons/IconSvgClowderLogo.vue'
import IconSvgCMAACCMDirectory from '@/components/Resource/Icons/IconSvgCMAACCMDirectory.vue'
import IconSvgCompTIAAppUsers from '@/components/Resource/Icons/IconSvgCompTIAAppUsers.vue'
import IconSvgCRNDailySupplement from '@/components/Resource/Icons/IconSvgCRNDailySupplement.vue'
import IconSvgDSEALegislativeAction from '@/components/Resource/Icons/IconSvgDSEALegislativeAction.vue'
import IconSvgHRLFABoardOfDirectors from '@/components/Resource/Icons/IconSvgHRLFABoardOfDirectors.vue'
import IconSvgILMANewsFeed from '@/components/Resource/Icons/IconSvgILMANewsFeed.vue'
import IconSvgMEMAHome from '@/components/Resource/Icons/IconSvgMEMAHome.vue'
import IconSvgMEMAAHome from '@/components/Resource/Icons/IconSvgMEMAAHome.vue'
import IconSvgMEMAHHome from '@/components/Resource/Icons/IconSvgMEMAHHome.vue'
import IconSvgMEMAMHome from '@/components/Resource/Icons/IconSvgMEMAMHome.vue'
import IconSvgMEMAOHome from '@/components/Resource/Icons/IconSvgMEMAOHome.vue'
import IconSvgMPANewsFeed from '@/components/Resource/Icons/IconSvgMPANewsFeed.vue'
import IconSvgNCIAConnect from '@/components/Resource/Icons/IconSvgNCIAConnect.vue'
import IconSvgNPMAMyNPMA from '@/components/Resource/Icons/IconSvgNPMAMyNPMA.vue'
import IconSvgNYSSCPAChapters from '@/components/Resource/Icons/IconSvgNYSSCPAChapters.vue'
import IconSvgNYSSCPAExchange from '@/components/Resource/Icons/IconSvgNYSSCPAExchange.vue'
import IconSvgNYSSCPAMentormatch from '@/components/Resource/Icons/IconSvgNYSSCPAMentormatch.vue'
import IconSvgNYSSCPAStatewideCommittees from '@/components/Resource/Icons/IconSvgNYSSCPAStatewideCommittees.vue'
import IconSvgQAScholarship from '@/components/Resource/Icons/IconSvgQAScholarship.vue'
import IconSvgSCRLAServSafe from '@/components/Resource/Icons/IconSvgSCRLAServSafe.vue'
import IconSvgSDBPNewsFeed from '@/components/Resource/Icons/IconSvgSDBPNewsFeed.vue'
import IconSvgSHMemorial from '@/components/Resource/Icons/IconSvgSHMemorial.vue'
import IconSvgTHYROIDNewsFeed from '@/components/Resource/Icons/IconSvgTHYROIDNewsFeed.vue'
import IconSvgZONTAMyZonta from '@/components/Resource/Icons/IconSvgZONTAMyZonta.vue'
import IconSvgGBANewsFeed from '@/components/Resource/Icons/IconSvgGBANewsFeed.vue'
import IconSvgNFOPActiveFit from '@/components/Resource/Icons/IconSvgNFOPActiveFit.vue'
import IconSvgSNMMIConnect from '@/components/Resource/Icons/IconSvgSNMMIConnect.vue'
import IconSvgASCRSEyeWorld from '@/components/Resource/Icons/IconSvgASCRSEyeWorld.vue'
import IconSvgPROLEGISMyProlegis from '@/components/Resource/Icons/IconSvgPROLEGISMyProlegis.vue'
import IconSvgPROLEGISBriefings from '@/components/Resource/Icons/IconSvgPROLEGISBriefings.vue'
import IconSvgDCAT from '@/components/Resource/Icons/IconSvgDCAT.vue'
import IconSvgNextGen from '@/components/Resource/Icons/IconSvgNextGen.vue'
import IconSvgNextGen2 from '@/components/Resource/Icons/IconSvgNextGen2.vue'
import IconSvgNYSSCPA from '@/components/Resource/Icons/IconSvgNYSSCPA.vue'
import IconSvgAsae from '@/components/Resource/Icons/IconSvgAsae.vue'
import IconSvgNews from '@/components/Resource/Icons/IconSvgNews.vue'
import IconSvgBinoculars from '@/components/Resource/Icons/IconSvgBinoculars.vue'
import IconSvgForYou from '@/components/Resource/Icons/IconSvgForYou.vue'
import IconSvgKey from '@/components/Resource/Icons/IconSvgKey.vue'
import IconSvgIdea from '@/components/Resource/Icons/IconSvgIdea.vue'
import IconSvgIcons8Support from '@/components/Resource/Icons/IconSvgIcons8Support.vue'
import IconSvgDocument from '@/components/Resource/Icons/IconSvgDocument.vue'
import IconSvgMusic from '@/components/Resource/Icons/IconSvgMusic.vue'
import IconSvgACPWebview from '@/components/Resource/Icons/IconSvgACPWebview.vue'
import IconSvgAFPMSummit2023 from '@/components/Resource/Icons/IconSvgAFPMSummit2023.vue'
import IconSvgAFPM1 from '@/components/Resource/Icons/IconSvgAFPM1.vue'
import IconSvgAFPM2 from '@/components/Resource/Icons/IconSvgAFPM2.vue'
import IconSvgAISESIcon from '@/components/Resource/Icons/IconSvgAISESIcon.vue'
import IconSvgIconBee from '@/components/Resource/Icons/IconSvgIconBee.vue'
import IconSvgAFPMLiveEvent from '@/components/Resource/Icons/IconSvgAFPMLiveEvent.vue'
import IconSvgPencil from '@/components/Resource/Icons/IconSvgPencil.vue'
import IconSvgPencil2 from '@/components/Resource/Icons/IconSvgPencil2.vue'
import IconSvgLike from '@/components/Resource/Icons/IconSvgLike.vue'
import IconSvgEye from '@/components/Resource/Icons/IconSvgEye.vue'
import IconSvgBookmark from '@/components/Resource/Icons/IconSvgBookmark.vue'
import IconSvgBookmarkEmpty from '@/components/Resource/Icons/IconSvgBookmarkEmpty.vue'
import IconSvgPauseCircle from '@/components/Resource/Icons/IconSvgPauseCircle.vue'
import IconSvgFolder2 from '@/components/Resource/Icons/IconSvgFolder2.vue'
import IconSvgComment from '@/components/Resource/Icons/IconSvgComment.vue'
import IconSvgPhone from '@/components/Resource/Icons/IconSvgPhone.vue'
import IconSvgPhoneEmpty from '@/components/Resource/Icons/IconSvgPhoneEmpty.vue'
import IconSvgChevronRight from '@/components/Resource/Icons/IconSvgChevronRight.vue'
import IconSvgChevronLeft from '@/components/Resource/Icons/IconSvgChevronLeft.vue'
import IconSvgGrid from '@/components/Resource/Icons/IconSvgGrid.vue'
import IconSvgGrid2 from '@/components/Resource/Icons/IconSvgGrid2.vue'
import IconSvgPlayerBack from '@/components/Resource/Icons/IconSvgPlayerBack.vue'
import IconSvgPlayerForward from '@/components/Resource/Icons/IconSvgPlayerForward.vue'
import IconSvgVolumeDown from '@/components/Resource/Icons/IconSvgVolumeDown.vue'
import IconSvgVolumeUp from '@/components/Resource/Icons/IconSvgVolumeUp.vue'
import IconSvgTraForkKnifeDrk from '@/components/Resource/Icons/IconSvgTraForkKnifeDrk.vue'
import IconSvgBothMessage from '@/components/Resource/Icons/IconSvgBothMessage.vue'
import IconSvgHearth from '@/components/Resource/Icons/IconSvgHearth.vue'
import IconSvgShare from '@/components/Resource/Icons/IconSvgShare.vue'
import IconSvgDelete from '@/components/Resource/Icons/IconSvgDelete.vue'
import IconSvgVector from '@/components/Resource/Icons/IconSvgVector.vue'
import IconSvgForward from '@/components/Resource/Icons/IconSvgForward.vue'
import IconSvgHashTag from '@/components/Resource/Icons/IconSvgHashTag.vue'
import IconSvgVideoLink from '@/components/Resource/Icons/IconSvgVideoLink.vue'
import IconSvgClose from '@/components/Resource/Icons/IconSvgClose.vue'
import IconSvgUp from '@/components/Resource/Icons/IconSvgUp.vue'
import IconSvgEllipsis from '@/components/Resource/Icons/IconSvgEllipsis.vue'
import IconSvgAttachment from '@/components/Resource/Icons/IconSvgAttachment.vue'
import IconSvgNote from '@/components/Resource/Icons/iconSvgNote.vue'
import IconSvgClowderTitleLogo from '@/components/Resource/Icons/IconSvgClowderTitleLogo.vue'
import IconSvgPinned from '@/components/Resource/Icons/IconSvgPinned.vue'
import IconSvgUnion from '@/components/Resource/Icons/IconSvgUnion.vue'
import IconSvgLogout from '@/components/Resource/Icons/IconSvgLogout.vue'
import IconSvgAddSchedule from '@/components/Resource/Icons/IconSvgAddSchedule.vue'
import IconSvgRemoveSchedule from '@/components/Resource/Icons/IconSvgRemoveSchedule.vue'
import IconSvgPlus from '@/components/Resource/Icons/IconSvgPlus.vue'
import IconSvgChart from '@/components/Resource/Icons/IconSvgChart.vue'
import IconSvgWrench2 from '@/components/Resource/Icons/IconSvgWrench2.vue'
import IconSvgLibrary from '@/components/Resource/Icons/IconSvgLibrary.vue'
import IconSvgBriefCase from '@/components/Resource/Icons/IconSvgBriefCase.vue'
import IconSvgMonitor from '@/components/Resource/Icons/IconSvgMonitor.vue'
import IconSvgPresentation from '@/components/Resource/Icons/IconSvgPresentation.vue'
import IconSvgCross from '@/components/Resource/Icons/IconSvgCross.vue'
import IconSvgApple from '@/components/Resource/Icons/IconSvgApple.vue'
import IconSvgClipboardList from '@/components/Resource/Icons/IconSvgClipboardList.vue'
import IconSvgLocation from '@/components/Resource/Icons/IconSvgLocation.vue'
import IconSvgSnmmi from '@/components/Resource/Icons/IconSvgSnmmi.vue'
import IconSvgSnmmiDirectory from '@/components/Resource/Icons/IconSvgSnmmiDirectory.vue'
import IconSvgSnnmiClinicalPractice from "@/components/Resource/Icons/IconSvgSnnmiClinicalPractice.vue";
import IconSvgSnmmiNuclearMedicineJournals from '@/components/Resource/Icons/IconSvgSnmmiNuclearMedicineJournals.vue'
import IconSvgSnmmiPodcast from '@/components/Resource/Icons/IconSvgSnmmiPodcast.vue'
import IconSvgSnmmiFollowUs from '@/components/Resource/Icons/IconSvgSnmmiFollowUs'
import IconSvgSnmmiSettings from '@/components/Resource/Icons/IconSvgSnmmiSettings.vue'
import IconSvgSnmmiNotifications from '@/components/Resource/Icons/IconSvgSnmmiNotifications.vue'
import IconSvgSnmmiMessages from '@/components/Resource/Icons/IconSvgSnmmiMessages'

export default {
	name: 'Icon',
	components: {
		IconSvgLocation,
		IconSvgForward,
		IconSvgVector,
		IconSvgShare,
		IconSvgHearth,
		IconSvgBank,
		IconSvgBook,
		IconSvgBookClosed,
		IconSvgBulb,
		IconSvgCalculator,
		IconSvgCategories,
		IconSvgBuy,
		IconSvgPin,
		IconSvgCertificat,
		IconSvgChair,
		IconSvgClock,
		IconSvgCommunity,
		IconSvgCompanyDirectory,
		IconSvgFolder,
		IconSvgGift,
		IconSvgGlobe,
		IconSvgGraduate,
		IconSvgGraph,
		IconSvgHeadSet,
		IconSvgJobs,
		IconSvgMegaphone,
		IconSvgMemberDirectory,
		IconSvgNotifications,
		IconSvgPartners,
		IconSvgScale,
		IconSvgSchool,
		IconSvgArrowUp,
		IconSvgBubble,
		IconSvgCalendarCheck,
		IconSvgCalendarStar,
		IconSvgCart,
		IconSvgCheck,
		IconSvgClip,
		IconSvgCloseFill,
		IconSvgCode,
		IconSvgCompass,
		IconSvgConnection,
		IconSvgConvention,
		IconSvgCovid,
		IconSvgDisplay,
		IconSvgDollar,
		IconSvgDownloads,
		IconSvgEmail,
		IconSvgEvents,
		IconSvgFacebook,
		IconSvgFlash,
		IconSvgForums,
		IconSvgGlobeCircle,
		IconSvgGroup,
		IconSvgHeadphones,
		IconSvgHigherLogic,
		IconSvgHome,
		IconSvgInfinity,
		IconSvgInfo,
		IconSvgInstagram,
		IconSvgLegislative,
		IconSvgLink,
		IconSvgLinkedin,
		IconSvgList,
		IconSvgLookupPeople,
		IconSvgMembershipCard,
		IconSvgMessages,
		IconSvgMore,
		IconSvgNewspaper,
		IconSvgPass,
		IconSvgPause,
		IconSvgPlay,
		IconSvgPlayCircle,
		IconSvgPlusFill,
		IconSvgProfile,
		IconSvgQr,
		IconSvgQuestion,
		IconSvgRefresh,
		IconSvgResources,
		IconSvgSearch,
		IconSvgSettings,
		IconSvgSort,
		IconSvgStar,
		IconSvgStarEmpty,
		IconSvgTarget,
		IconSvgTeacher,
		IconSvgTwitter,
		IconSvgUsa,
		IconSvgUsers,
		IconSvgWallet,
		IconSvgWrench,
		IconSvgACPAMyprofile,
		IconSvgACPANewsFeed,
		IconSvgACTFLCentral,
		IconSvgAGDSubmitCEOnline,
		IconSvgAMSNHome,
		IconSvgADAPhysicianPortal,
		IconSvgAPAUpdates,
		IconSvgAPSNNews,
		IconSvgASTSFoundation,
		IconSvgClowderLogo,
		IconSvgCMAACCMDirectory,
		IconSvgCompTIAAppUsers,
		IconSvgCRNDailySupplement,
		IconSvgDSEALegislativeAction,
		IconSvgHRLFABoardOfDirectors,
		IconSvgILMANewsFeed,
		IconSvgMEMAHome,
		IconSvgMEMAAHome,
		IconSvgMEMAHHome,
		IconSvgMEMAMHome,
		IconSvgMEMAOHome,
		IconSvgMPANewsFeed,
		IconSvgNCIAConnect,
		IconSvgNPMAMyNPMA,
		IconSvgNYSSCPAChapters,
		IconSvgNYSSCPAExchange,
		IconSvgNYSSCPAMentormatch,
		IconSvgNYSSCPAStatewideCommittees,
		IconSvgQAScholarship,
		IconSvgSCRLAServSafe,
		IconSvgSDBPNewsFeed,
		IconSvgSHMemorial,
		IconSvgTHYROIDNewsFeed,
		IconSvgZONTAMyZonta,
		IconSvgGBANewsFeed,
		IconSvgNFOPActiveFit,
		IconSvgSNMMIConnect,
		IconSvgASCRSEyeWorld,
		IconSvgPROLEGISMyProlegis,
		IconSvgPROLEGISBriefings,
		IconSvgDCAT,
		IconSvgNextGen,
		IconSvgNextGen2,
		IconSvgNYSSCPA,
		IconSvgAsae,
		IconSvgNews,
		IconSvgBinoculars,
		IconSvgForYou,
		IconSvgKey,
		IconSvgIdea,
		IconSvgIcons8Support,
		IconSvgDocument,
		IconSvgMusic,
		IconSvgACPWebview,
		IconSvgAFPMSummit2023,
		IconSvgAFPM1,
		IconSvgAFPM2,
		IconSvgAISESIcon,
		IconSvgIconBee,
		IconSvgAFPMLiveEvent,
		IconSvgPencil,
		IconSvgPencil2,
		IconSvgLike,
		IconSvgEye,
		IconSvgBookmark,
		IconSvgBookmarkEmpty,
		IconSvgPauseCircle,
		IconSvgFolder2,
		IconSvgComment,
		IconSvgPhone,
		IconSvgPhoneEmpty,
		IconSvgChevronRight,
		IconSvgChevronLeft,
		IconSvgGrid,
		IconSvgGrid2,
		IconSvgPlayerBack,
		IconSvgPlayerForward,
		IconSvgVolumeDown,
		IconSvgVolumeUp,
		IconSvgTraForkKnifeDrk,
		IconSvgBothMessage,
		IconSvgAttachment,
		IconSvgDelete,
		IconSvgHashTag,
		IconSvgVideoLink,
		IconSvgClose,
		IconSvgUp,
		IconSvgEllipsis,
		IconSvgNote,
		IconSvgClowderTitleLogo,
		IconSvgPinned,
		IconSvgUnion,
		IconSvgLogout,
		IconSvgAddSchedule,
		IconSvgRemoveSchedule,
		IconSvgPlus,
		IconSvgChart,
		IconSvgWrench2,
		IconSvgLibrary,
		IconSvgBriefCase,
		IconSvgMonitor,
		IconSvgPresentation,
		IconSvgCross,
		IconSvgApple,
		IconSvgClipboardList,
    IconSvgSnmmi,
    IconSvgSnmmiDirectory,
    IconSvgSnnmiClinicalPractice,
    IconSvgSnmmiNuclearMedicineJournals,
    IconSvgSnmmiPodcast,
    IconSvgSnmmiFollowUs,
    IconSvgSnmmiSettings,
    IconSvgSnmmiNotifications,
    IconSvgSnmmiMessages
	},
	props: {
		type: {
			type: String,
			default: '',
		},
		isActive: {
			type: Boolean,
			default: true,
		},
		strokeColor: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: '',
		},
		size: {
			type: Number,
			default: null,
		},
		pr: {
			type: Number,
			default: null,
		},
	},
	computed: {
		...mapGetters('settings', ['styles']),

		toLowerCaseType() {
			return this.type.toLowerCase()
		},
		paddingRight() {
			return this.pr ? `${this.pr}px` : null
		},
	},
}
</script>

<style lang="scss" scoped>
.custom-icon {
	display: flex;
	align-items: center;

	div {
		display: flex;
		align-items: center;
	}
}
</style>
